<template>
  <div
    v-show="menu.show"
    class="menu-wrapper"
    :style="{ top: menu.y + 'px', left: menu.x + 'px' }"
  >
    <PlusOutlined @click="eventFire('add', $event)" />
    <ArrowUpOutlined @click="eventFire('up', $event)" />
    <ArrowDownOutlined @click="eventFire('down', $event)" />
    <DeleteOutlined @click="eventFire('del', $event)" />
  </div>
</template>
<script>
import {
  PlusOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  DeleteOutlined,
} from "@ant-design/icons-vue";

export default {
  props: {
    menu: Object
  },
  components: {
    PlusOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
    DeleteOutlined,
  },
  data() {
    return {
    };
  },
  watch: {
    menu: {
      deep: true,
      handler() {
        if (!this.menu.show) return

        let $body = document.body;
        const clickHandler = () => {
          this.$emit('cancel')
          $body.removeEventListener("click", clickHandler);
        };
        $body.addEventListener("click", clickHandler);
      }
    }
  },
  mounted() {
  },
  methods: {
    eventFire(type, e) {
        this.$emit(type, e)
    }
  },
};
</script>
<style lang="scss" scoped>
.menu-wrapper {
  position: absolute;
  display: inline-block;
  padding: 10px;
  background: #f7fafe;
  border: 1px solid #ddd;
  border-radius: 6px;
  opacity: 0.8;
  span {
    padding: 6px;
    margin: 2px;
    border-radius: 3px;
  }
  span:hover {
    background: #217ef7;
    color: #fff;
    transition: background 0.3s;
    cursor: pointer;
  }
}
</style>
